import React, { Component } from 'react';
import { Table, Button, Icon, Divider, Modal, message, Spin } from 'antd';
import { connect } from 'react-redux';

import { getUsersList, deleteUser, changeCurrentUserPage } from '../../../../../../actions';
import { rolesToString } from '../../../../../../utils/roles';

class UsersTable extends Component {
  state = {
    pagination: {
      total: this.props.users.total,
    },
  }

  componentDidMount() {
    this.props.getUsersList({
      limit: this.props.users.current * 10,
      skip: this.props.users.current - 1,
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.users.total !== this.props.users.total) {
      this.setState({
        pagination: {
          total: nextProps.users.total,
        },
      });
    }
  }

  handlePaginationChange = (current) => {
    this.props.changeCurrentUserPage(current);
  }

  columns = [{
    title: 'Mã GV',
    dataIndex: 'lecturerId',
    render: (text, record) => (
      <a href={`/giang-vien/${record.key}`} target='_blank'>{text}</a>
    ),
    width: 120,
  }, {
    title: 'Họ và tên',
    dataIndex: 'fullname',
    width: 250,
  }, {
    title: 'Vai trò',
    dataIndex: 'role',
  }, {
    title: 'Tùy chỉnh',
    key: 'action',
    render: (text, record) => (
      <span>
        <a role='button' onClick={() => { this.handleEdit(record.key); }}><Icon type="edit" />{' '}Sửa</a>
        <Divider type="vertical" />
        <a role='button' onClick={() => { this.handleDelete(record.key); }}><Icon type="delete" />{' '}Xóa</a>
      </span>
    ),
    width: 100,
  }];

  createUser = () => {
    this.props.showUserEditor();
  }

  handleEdit = (key) => {
    const user = this.props.users.usersList.find(item => item.lecturerId === key);
    this.props.showUserEditor(user);
  }

  handleDelete = (key) => {
    Modal.confirm({
      title: `Bạn chắc chắn xóa người dùng "${key}"`,
      onText: 'Xóa',
      okType: 'danger',
      cancleText: 'Hủy',
      onOk: () => {
        this.props.deleteUser({
          lecturerId: key,
          response: {
            success: async () => {
              message.success('Xóa người dùng thành công');
            },
            failure: async (msg = 'Xóa người dùng không thành công') => {
              message.error(msg);
            },
          },
        });
      },
      onCancel: () => {

      },
    });
  }

  handleTableChange = (pagination) => {
    const pager = { ...this.state.pagination };
    pager.current = pagination.current;
    this.setState({
      pagination: pager,
    });
    this.props.getUsersList({
      limit: pagination.pageSize,
      skip: (pagination.current - 1) * pagination.pageSize,
    });
  }

  render() {
    const { users: { loading, usersList, current } } = this.props;
    const { pagination } = this.state;

    const tableData = usersList.map(user => ({
      key: user.lecturerId,
      lecturerId: user.lecturerId,
      fullname: user.fullname,
      role: rolesToString(user.role),
    }));

    return (
      <div>
        <p style={{ display: 'flex', justifyContent: 'center' }}>
          <Button
            type="primary"
            onClick={this.createUser}
            style={{ marginTop: '10px' }}
          >
            <Icon type="file-add" />Tạo người dùng mới
          </Button>
        </p>      
      
        {(loading && !tableData.length)
          ? <Spin />
          : <Table
            columns={this.columns}
            dataSource={tableData}
            pagination={{
              ...pagination,
              current,
              onChange: this.handlePaginationChange,
            }}
            onChange={this.handleTableChange}
          />}
          
        <p style={{ display: 'flex', justifyContent: 'center' }}>
          <Button
            type="primary"
            onClick={this.createUser}
            style={{ marginTop: '10px' }}
          >
            <Icon type="file-add" />Tạo người dùng mới
          </Button>
        </p>
        
      </div>
    );
  }
}

const mapStateToProps = state => ({
  users: state.users,
});

const mapDispatchToProps = {
  getUsersList,
  deleteUser,
  changeCurrentUserPage,
};

export default connect(mapStateToProps, mapDispatchToProps)(UsersTable);



// WEBPACK FOOTER //
// ./src/screens/Dashboard/Categories/Governance/Users/UsersTable/UsersTable.js